import {
  PrimaryBlockType,
  processLayoutOptions,
  Shared,
  LayoutOptions,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

enum Placement {
  center = "center",
  left = "left",
  right = "right",
}

export const layoutOptions = {
  ...LayoutOptions.BackgroundColor,
  ...LayoutOptions.TextAlignment,
  ...{
    placement: LayoutOptions.Options(Placement),
  },
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type FormType = {
  tagline: string;
  title: string;
  description: string;
  image: Shared.Props.MediaProp;
} & PrimaryBlockType<LayoutProps> &
  Shared.Props.FormProps;
